import React from 'react';
import { CFormFeedback, CFormLabel, CFormTextarea, CPopover } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';

const SimpleTextAreaGroup = ({
     id,
     label,
     className,
     classNameWrap,
     isRequired,
     isValidate,
     value,
     error,
     handleChange,
     disabled,
     rows,
     placeholder,
     tooltip,
     actionComponent,
}) => {
     return (
          <div className={`form-group text-area-form${classNameWrap ? ` ${classNameWrap}` : ''}${className ? ` ${className}` : ''}`}>
               {label && (
                    <CFormLabel htmlFor={id} className={`${actionComponent ? 'd-flex align-items-center' : ''}`}>
                         {label && <span className="me-1">{label}</span>}
                         {tooltip && (
                              <CPopover content={tooltip} placement="top" trigger="hover">
                                   <CIcon icon="icon-info-cilcle" className="ml-2" />
                              </CPopover>
                         )}
                         {isRequired && <span className="text-danger">*</span>}
                         {actionComponent}
                    </CFormLabel>
               )}

               <CFormTextarea
                    className="input-custom"
                    placeholder={placeholder ?? 'Type your content here'}
                    id={id}
                    name={id}
                    invalid={(isRequired || isValidate) && !!error}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    rows={rows}
               />
               {(isRequired || isValidate) && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleTextAreaGroup.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     isRequired: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     handleChange: PropTypes.func,
     disabled: PropTypes.bool,
     rows: PropTypes.string,
     tooltip: PropTypes.string,
     actionComponent: PropTypes.node,
};

SimpleTextAreaGroup.defaultProps = {
     value: '',
     rows: '1',
};

export default SimpleTextAreaGroup;
